import { useState } from 'react'

import TruncateLines from '@components/TruncateLines'
import SharedContactsIcon from '@components/icons/SharedContactsIcon'
import { useAuthContext } from '@modules/auth/hooks/useAuthContext'
import { isP1PlusEcommerceUser } from '@modules/auth/types'
import { ChatType } from '@modules/chat/types'
import { useChatContext } from '@modules/chat/useChatContext'
import { Delegate } from '@modules/search/types'
import ChatIcon from '@mui/icons-material/Chat'
import { Box } from '@mui/material'
import Link from '@mui/material/Link'

import {
  CardAvatar,
  CardContactButton,
  CardTopSection,
  DelegateCardIconsContainer,
  DelegateCardSubtitle,
  DelegateCardTitle,
  DelegateCardWrapper,
} from './index.styles'

interface DelegateCardProps {
  delegate: Delegate
  companyId?: number
  showContactBtn: boolean
  isContactButtonEnabled: (companyId: number | null) => boolean
}

const TITLE_ONE_LINE_HEIGHT = 24

const DelegateCard = ({ delegate, companyId, showContactBtn, isContactButtonEnabled }: DelegateCardProps) => {
  const { openChatModal } = useChatContext()

  const [subtitleLines, setSubtitleLines] = useState(3)
  const { user } = useAuthContext()
  const isEcommerce = isP1PlusEcommerceUser(user?.subscriptionLevel || 0)
  const name = `${delegate?.firstName} ${delegate?.lastName}`

  const handleUpdateSubtitleLines = (ref: HTMLDivElement) => {
    if (ref?.offsetHeight > TITLE_ONE_LINE_HEIGHT) {
      setSubtitleLines(2)
    }
  }

  return (
    <DelegateCardWrapper>
      <CardTopSection>
        <CardAvatar src={delegate?.profilePicture} />
        <DelegateCardIconsContainer>
          {delegate.hasSharedInfo && (
            <Box height={17}>
              <SharedContactsIcon />
            </Box>
          )}
          {companyId && showContactBtn && !isEcommerce && isContactButtonEnabled(companyId) ? (
            <CardContactButton
              variant="text"
              data-testid="contact_btn"
              id="contact_button-profile_all_delegates"
              onClick={() =>
                openChatModal({
                  companyId,
                  delegates: [delegate] as unknown as Delegate[],
                  chatType: ChatType.DIRECT,
                })
              }
            >
              <ChatIcon viewBox="0 2 24 24" />
            </CardContactButton>
          ) : null}
        </DelegateCardIconsContainer>
      </CardTopSection>
      <Link href={`/plus/profile/${delegate?.id}/delegate`} underline="none" id="profile_all_delegates-profile_name">
        <DelegateCardTitle ref={handleUpdateSubtitleLines}>
          <TruncateLines lines={2}>{name}</TruncateLines>
        </DelegateCardTitle>
      </Link>
      <DelegateCardSubtitle>
        <TruncateLines lines={subtitleLines} lineHeight={1.3}>
          {delegate?.jobTitle}
        </TruncateLines>
      </DelegateCardSubtitle>
    </DelegateCardWrapper>
  )
}

export default DelegateCard
